import React from 'react';
import styled from 'styled-components';

import { useTextEditorContext } from 'components/text_editor/text_editor_context';

const StyledPhoneNumberHighlight = styled.span`
  border-bottom: 1px dashed ${p => p.theme.colors.green400};
  color: ${p => p.theme.colors.green400};
  cursor: pointer;

  &:hover {
    color: ${p => p.theme.colors.green600};
  }
`;

export default function PhoneNumberHighlight({ attributes, children, editor, node, onChange, start, end, text }) {
  const { data, setDataValue } = useTextEditorContext();

  const onClick = () => {
    if (data.phoneNumberHighlight) {
      setDataValue('phoneNumberHighlight', null);
    } else {
      setDataValue('phoneNumberHighlight', {
        key: node.key,
        start,
        end,
        text,
      });
    }
  };

  return (
    <StyledPhoneNumberHighlight
      data-aid="phone-number-highlight"
      data-end={end}
      data-key={node.key}
      data-start={start}
      onClick={onClick}
      {...attributes}
    >
      {children}
    </StyledPhoneNumberHighlight>
  );
}
